const toDate = (value) => {
    if (!value) return value;
    if (value instanceof Date) return value;

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date;
};

export const normalizeTransportDocumentDates = (document) => {
    if (!document) return document;

    return {
        ...document,
        issueDate: toDate(document.issueDate),
        address: (document.address ?? []).map((address) => ({
            ...address,
            date: toDate(address?.date),
        })),
    };
};
